module.exports = __webpack_public_path__ + "static/media/ic_trash.544ead1f.svg";